"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sideNav = _interopRequireDefault(require("../../../components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("../../../components/foot-nav"));
var _default = exports.default = {
  name: 'newWaybill',
  components: {
    footNav: _footNav.default,
    sideNav: _sideNav.default
  },
  data: function data() {
    return {
      showAppDownload: false
    };
  },
  methods: {
    //创建运单
    clickToCreateWaybill: function clickToCreateWaybill() {
      this.showAppDownload = true;
    }
  }
};